<template>
    <div class="Background">
        <v-row>

            <v-col sm="12" cols="6">

                <!--img-->
                <div class="Live-video-container">
                    <iframe scrolling="no" ref="iframe" :src="EMBEDIEDURL" frameborder="0" allowfullscreen @load="temp"
                        @playing="resizeVideo" style="height: 500px;"></iframe>

                    <!-- <TextButton v-if="livestatus" buttonText="LIVE 중지" iconColor="red" icon="mdi-stop-circle-outline"
                        @click="liveonoff" style="position: absolute;top: 20px;left: 20px;" />
                    <TextButton v-else buttonText="LIVE 연결" icon="mdi-access-point" isPrimary @click="liveonoff"
                        style="position: absolute;top: 20px;left: 20px;" /> -->
                </div>
                <div class="mt-2" style="display: flex;justify-content: space-between;">
                    <div class="suport_box">
                        <strong>새로고침 버튼을 눌러주셔야 라이브 방송이 스트림온에 반영됩니다.</strong>
                    </div>
                    <div>
                        <IconButton icon="mdi-refresh" class="ml-2" small @click="refresh" height="41px" />
                    </div>
                </div>
            </v-col>

            <v-col sm="12" cols="6">
                <v-row>
                    <v-col class="mr-5">
                        <v-row>
                            <v-col>
                                <h3 class="tabletitle">스트리밍 상세 정보</h3>
                            </v-col>
                            <!-- <v-col class="text-right">
                                <TextButton buttonText="저장" small isPrimary @click="saveChanges" />
                            </v-col> -->
                        </v-row>
                        <v-simple-table>
                            <template>
                                <thead>
                                    <tr>
                                        <th class="thead_custom_left thead_custom_top pa-3">
                                            Live 스트리밍
                                        </th>
                                        <th class="thead_custom_right thead_custom_top pa-3">
                                            <span><Input placeholder="name" :value="stream_name" viewType="name"
                                                    :disabled="true" /></span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="thead_custom_left pa-3">
                                            Live 송출
                                        </th>
                                        <th class="thead_custom_right pa-3">
                                            <CustomSwitch :switchState="switchStates.publishing"
                                                :toggleSwitch="() => toggleSwitch('publishing')" />
                                        </th>
                                        <!-- <th class="thead_custom_left pa-3">
                                            퍼블리싱
                                        </th>
                                        <th class="thead_custom_right pa-3">
                                            <CustomSwitch :switchState="switchStates.publishing"
                                                :toggleSwitch="() => toggleSwitch('publishing')" />
                                        </th> -->
                                    </tr>
                                    <tr>
                                        <th class="thead_custom_left pa-3">
                                            레코딩
                                        </th>
                                        <th class="thead_custom_right pa-3" style="display: flex;">
                                            <CustomSwitch :switchState="switchStates.recording"
                                                :toggleSwitch="() => toggleSwitch('recording')" />

                                            <!--녹화 off-->
                                            <span v-if="recorderState === 'stop'" class="reco_status recording_off">
                                                <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                                                녹화중이 아닙니다.
                                            </span>


                                            <!-- 녹화 on -->
                                            <span v-if="recorderState === 'progress'" class="reco_status recording_on">
                                                <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                                                녹화 중입니다.
                                            </span>


                                            <!-- 녹화를 기다리는 중 -->
                                            <span v-if="recorderState === 'wait'" class="reco_status recording_waiting">
                                                <v-icon small class="mdi mdi-clock-outline mr-1" color="#d33333" />
                                                영상을 준비하는 중입니다.
                                            </span>
                                        </th>
                                    </tr>

                                </thead>
                            </template>
                        </v-simple-table>
                    </v-col>

                    <v-col>
                        <h3 class="tabletitle">
                            INFO
                        </h3>

                        <v-simple-table>
                            <template>
                                <thead>
                                    <tr>
                                        <th class="thead_custom_left thead_custom_top pa-3">
                                            <v-row>
                                                <v-col cols="8">
                                                    <h4>PLAYBACK URL</h4>
                                                </v-col>
                                                <v-col cols="4">
                                                    <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                                        @click="copyToClipboard(HLS)" />
                                                </v-col>
                                            </v-row>
                                        </th>
                                        <th class="thead_custom_right thead_custom_top pa-3">
                                            <span class="text_box"> {{ HLS }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="thead_custom_left pa-3">
                                            <v-row>
                                                <v-col cols="8">
                                                    <h4>EMBEDIED URL</h4>  
                                                </v-col>
                                                <v-col cols="4">
                                                    <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                                        @click="copyToClipboard(EMBEDIEDURL)" />
                                                </v-col>
                                            </v-row>
                                        </th>
                                        <th class="thead_custom_right pa-3">
                                            <span class="text_box">{{ EMBEDIEDURL }}</span>
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="thead_custom_left pa-3">
                                            <v-row>
                                                <v-col cols="8">
                                                    <h4>THUMBNAIL URL</h4>
                                                </v-col>
                                                <v-col cols="4">
                                                    <TextButton buttonText="copy" :xsmall="true" class="ml-1"
                                                        @click="copyToClipboard(ThumbnailUrl)" />
                                                </v-col>
                                            </v-row>
                                        </th>
                                        <th class="thead_custom_right pa-3">
                                            <span class="text_box"> {{ ThumbnailUrl }} </span>
                                        </th>
                                    </tr>
                                </thead>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>

            </v-col>
        </v-row>
    </div>

</template>

<script>
import Input from '@/components/ui/form/FormInput.vue';
import TextButton from '@/components/ui/button/TextButton2.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import LiveStreamApi from "@/api/livestream/LiveStreamApi";
import { mapActions, mapState } from 'vuex';


export default {
    components: {
        Input,
        TextButton,
        CustomSwitch,
        IconButton,
    },
    data() {
        return {
            stream_name: '',
            //OnpublishServer: '',
            application: '',
            live_status: '',
            livestatus: false,
            switchStates: {
                publishing: false,
                recording: false,
            },
            recorderState: '',
        }
    },
    computed: {
        EMBEDIEDURL() {
            return `${window.location.protocol}//${window.location.host}/player?` + this.HLS;
        },
        HLS() {
            return 'https://' + this.wowzaOrigin + '/' + this.application + '/' + this.stream_name + '.stream/playlist.m3u8';
        },
        ThumbnailUrl() {
            return 'https://' + this.wowzaOrigin + ':8086/thumbnail?application=' + this.application + '&streamname=' + this.stream_name + '.stream&size=640x360&fitmode=letterbox'
        },
        isLive() {
            return this.switchStates.publishing;
        },
        isRecording() {
            return this.switchStates.recording;
        },
        OnpublishServer() {
            return 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
        }
    },
    methods: {
        // ...mapActions('livestatus', ['toggleSwitch', 'saveSettings']),
        // async saveChanges() {
        //     const frontUrl = `${window.location.protocol}//${window.location.host}`;
        //     const uuid = this.$route.params.uuid;
        //     const data = {
        //         ip: frontUrl,
        //         uuid: uuid,
        //         publishing: this.switchStates ? this.switchStates.publishing : false,
        //         recording: this.switchStates ? this.switchStates.recording : false,
        //         stream_name: this.stream_name
        //     };
        //     //console.log('data', data);
        //     const success = await this.$store.dispatch('livestatus/saveSettings', data);
        //     if (success) {
        //         this.$emit('settingsSaved');
        //     }
        // },
        copyToClipboard(textToCopy) {
            this.$copyText(textToCopy)
                .then(() => {

                })
                .catch(() => {
                    alert('Failed to copy text.');
                });
        },
        refreshIframe() {
            const originalURL = this.EMBEDIEDURL;
            this.$refs.iframe.src = '';
            this.$nextTick(() => {
                this.$refs.iframe.src = originalURL;
            });
        },
        async liveData(uuid) {
            try {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ip: frontUrl,
                    uuid: uuid,
                };
                const response = await LiveStreamApi.detailApi(data);
                this.application = response.item.application;
                this.stream_name = response.item.stream_name;
                this.live_status = response.item.pull_stream_status;
                this.switchStates.publishing = response.item.pull_stream_status === 1;
                // this.switchStates.publishing = response.item.pb_accept == '1';
                // this.switchStates.recording = response.item.record_status == '1';
                this.cname = response.domain;

            } catch (error) {
                console.error('error', error);
            }
        },
        temp() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            if (!video) return;
            video.poster = "/streamon.png";
        },
        resizeVideo() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            const iframeDocument = iframe.contentWindow.document;
            if (!video) return;

            const container = iframe.parentElement;
            const containerWidth = container.offsetWidth;
            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;

            if (aspectRatio < 1) {
                container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
            } else {
                container.style.paddingBottom = '56.25%';
            }

            video.autoplay = true;
            video.play();

        },
        refresh() {
            const uuid = this.$route.params.uuid;
            this.liveData(uuid);
        },
        async getApplication() {

            try {
                const response = await LiveStreamApi.getApplicationApi();
                console.log('res', response.wowza);
                if (response.status === 1) {
                    // const applicationData = response.application;
                    //const wowzaData = response.data.data;
                    //const wowzaOrigin = response.wowza;

                    // this.application = applicationData;
                    //this.wowzaData = wowzaData;
                    this.wowzaOrigin = response.wowza;
                    // this.OnpublishServer = 'rtmp://' + this.wowzaOrigin + '/' + this.application + '/';
                } else {
                    console.error('Error:', response.message);
                }
            } catch (error) {
                console.error('Error:', error);
            }
        },
        async toggleSwitch(switchKey) {
            try {
                const newState = !this.switchStates[switchKey];
                let response;

                if (switchKey === 'recording') {
                    response = await this.updateRecordingStatus(newState);
                } else if (switchKey === 'publishing') {
                    response = await this.updatePublishingStatus(newState);
                }

                if (response && response.status === 1) {
                    this.switchStates[switchKey] = newState;
                    console.log(`${switchKey} 스위치가 ${newState ? '켜짐' : '꺼짐'}으로 전환됨`);
                    setTimeout(() => {
                        this.pullStatus();
                    }, 2000);
                } else {
                    console.error('Error');
                }
            } catch (error) {
                console.error('Error', error);
            }
        },
        async updateRecordingStatus(newState) {
            console.log('recording');
            const data = { streamName: this.stream_name, status: newState ? 1 : 0, application: this.application };
            return await LiveStreamApi.updateRecordingOnOffApi(data);
        },
        async updatePublishingStatus(newState) {
            console.log('stream');
            const data = { streamName: this.stream_name, status: newState ? 1 : 0, application: this.application };
            return await LiveStreamApi.updateStreamOnOffApi(data);
        },
        async pullStatus() {
            try {
                const data = {
                    recorderName: this.stream_name,
                    application: this.application
                }
                const response = await LiveStreamApi.checkStatus(data);
                if (response.status === '1') {
                    //레코딩 상태는 on이지만 영상재생에 따른 상태
                    if (response.recorderState === 'Waiting for stream') {
                        this.recorderState = 'wait';
                        this.switchStates.recording = false;
                    } else if (response.recorderState === 'Recording in Progress') {
                        this.recorderState = 'progress';
                        this.switchStates.recording = true;
                    } else {
                        this.recorderState = 'stop';
                        this.switchStates.recording = false;
                    }
                } else if (response.status === '2') {
                    // recorder not found일 때
                    this.recorderState = 'stop';
                    this.switchStates.recording = false;
                }

            } catch (error) {
                console.error('Error', error);
            }
        },

    },
    async beforeMount() {
        const uuid = this.$route.params.uuid;
        await this.getApplication();

        //await this.pullLoadBalancer();
        await this.liveData(uuid);
        this.pullStatus();
    },
    // mounted() {
    //     setInterval(() => {
    //         this.pullStatus();
    //     }, 500000);
    // },
    watch: {
        'switchStates.publishing'(newVal) {
            if (newVal) {
                this.refreshIframe();
                this.pullStatus();
            }
        }
    }
}
</script>

<style>
.cont_title {
    margin-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #000;
    font-size: 18px;
}

.tabletitle {
    font-size: 18px;
    padding-bottom: 10px;
}

.left_wraper {
    width: 800px !important;
}

@media only screen and (max-width: 600px) {
    .lr_wrapper {
        display: block;
    }

    .right_wraper {
        margin: 0px;
    }
}

.right_wraper {
    width: 100%;
    margin-left: 20px;
}

.text_box {
    word-break: break-all;
    color: #888;
    width: 100%;
}

.text-left {}

.table_text {
    background: #fff;
}

iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.Live-video-container video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.Live-video-container {
    position: relative;
    background-color: black;
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 12px;
}

.thumbnail-wrapper {
    position: relative;
    width: 300px;
    height: 200px;
}

.thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.reco_status {
    line-height: 14px;
    margin-left: 10px;
    padding: 4px 8px 4px 8px;
    border-radius: 2px;
}

.reco_status.recording_on {
    background: #ffe7e7;
    color: #d33333;
}

.reco_status.recording_off {
    background: #f4f4f4;
    color: #696969;
}

.reco_status.recording_waiting {
    background: #fff5df;
    color: #e69b3f;
}

@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.blinking {
    animation: blink 1.3s infinite;
}
</style>